import ListPopover from './ListPopover'

export default ListPopover



// WEBPACK FOOTER //
// ./src/legacy/containers/Popovers/ListPopover/index.js